import { useCallback } from "react";
import { useNavigate } from "react-router";

import { useAppDispatch } from "@redux/hooks";
import { checkEndorsementUnderwriting } from "@redux/slices/endorsement";
import { needsUnderwritingReview } from "@redux/slices/endorsement/isUnderwritingFailed";
import { EndorsementRoutes, navigateToEndorsementStep } from "@routing/paths";

export const useCheckUnderwriting = (
  policyLocator: string,
  endorsementId: string | null
) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  return useCallback(async () => {
    const result = await dispatch(checkEndorsementUnderwriting());
    if (!checkEndorsementUnderwriting.fulfilled.match(result)) return false;

    const { decision, status, notes } = result.payload;
    const needsReview = needsUnderwritingReview({
      underwritingDecision: decision,
      status,
      underwritingNotes: notes,
    });
    if (needsReview) {
      await navigateToEndorsementStep(
        navigate,
        policyLocator,
        EndorsementRoutes.UW_REVIEW,
        { endorsementId }
      );
    }

    return !needsReview;
  }, [dispatch, navigate, policyLocator, endorsementId]);
};
